export const DEFAULT_DESIGN_OPACITY = 100;
